import { render, staticRenderFns } from "./WalkingQuestion.vue?vue&type=template&id=738161a4&scoped=true"
import script from "./WalkingQuestion.vue?vue&type=script&lang=ts"
export * from "./WalkingQuestion.vue?vue&type=script&lang=ts"
import style0 from "./WalkingQuestion.vue?vue&type=style&index=0&id=738161a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738161a4",
  null
  
)

export default component.exports